import { useQuery } from '@tanstack/react-query';
import { getDownloadTemplateHourlyLaunch } from 'services/api/requests/uploads/uploads';

export const useDownloadTemplateHourlyLaunch = () => {
	return useQuery(
		['download-template-hourlyLaunch'],
		getDownloadTemplateHourlyLaunch,
		{
			refetchOnWindowFocus: false,
			enabled: false,
		}
	);
};
